import { adaptNotificationData } from './../../../adapters/notificationData.adapter'
import { axios } from 'src/api'
import { ApiGetNotificationsParams, ApiGetNotificationsResponse } from './isloggedinwebsocket.types'

export const apiGetNotifications = async ({
  serverPath,
  userToken
}:ApiGetNotificationsParams) => {
  const response = await axios.post<ApiGetNotificationsResponse>(`https://${serverPath}/sialdPMS/web/resourcescrossorigin/user/isloggedinwebsocket`, {
    userToken
  })
  if (!response.data.ok) throw new Error(`error getting notifications: https://${serverPath}/sialdPMS/web/resourcescrossorigin/user/isloggedinwebsocket`)
  const adaptedRes = adaptNotificationData(response.data)
  return adaptedRes
}
